export class Order {
    public OrderId: number;
    public OrderLocation: string;
    public OrderStatus: string;
    public Created: Date;
}
